import React, { useState } from "react";
import { MessageChatCircle } from "@untitledui/icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import FeedbackForm from "./FeedbackForm";
import { selectSessionTimeoutOpen } from "@/store/userSlice";

const FeedbackButton: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const sessionTimeoutOpen = useSelector(selectSessionTimeoutOpen);
  const { t } = useTranslation();

  if (sessionTimeoutOpen) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setShowForm(true)}
        className="
          fixed
          bottom-[5.5rem]
          right-3
          sm:bottom-[6.25rem]
          sm:right-4
          md:bottom-[7.5rem]
          md:right-6
          lg:bottom-[5.5rem]
          z-[9999]
          flex
          items-center
          justify-center
          gap-2
          rounded-full
          bg-[#D35400]
          text-white
          shadow-lg
          transition-all
          hover:bg-[#B94700]
          hover:shadow-xl
          px-4
          py-3
        "
      >
        <MessageChatCircle className="h-5 w-5 shrink-0" />

        <span className="hidden md:inline">
          {t("feedbackForm.title")}
        </span>
      </button>

      <FeedbackForm
        open={showForm}
        onClose={() => setShowForm(false)}
      />
    </>
  );
};

export default FeedbackButton;